import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { InstallBanner } from "@/components/InstallBanner";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import SubjectsPage from "@/pages/SubjectsPage";
import ClassesPage from "@/pages/ClassesPage";
import TopicsPage from "@/pages/TopicsPage";
import ChatPage from "@/pages/ChatPage";
import QuizPage from "@/pages/QuizPage";
import MaterialsPage from "@/pages/MaterialsPage";
import PricingPage from "@/pages/PricingPage";
import ProgressPage from "@/pages/ProgressPage";
import ChallengesPage from "@/pages/ChallengesPage";
import PastPapersPage from "@/pages/PastPapersPage";
import AboutPage from "@/pages/legal/AboutPage";
import ContactPage from "@/pages/legal/ContactPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import TermsPage from "@/pages/legal/TermsPage";
import RefundPage from "@/pages/legal/RefundPage";
import DeleteAccountPage from "@/pages/legal/DeleteAccountPage";

const TOAST_OPTIONS = {
  style: { borderRadius: "16px", fontWeight: 600, zIndex: 30 },
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SubscriptionProvider>
          <Toaster
            position="top-right"
            duration={2500}
            toastOptions={TOAST_OPTIONS}
          />
          <InstallBanner />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund" element={<RefundPage />} />
            {/* /legal/* aliases — used by Play Store listing, app store reviewers
                and any external links. Keeps the short /privacy etc. working too. */}
            <Route path="/legal/about" element={<AboutPage />} />
            <Route path="/legal/contact" element={<ContactPage />} />
            <Route path="/legal/privacy" element={<PrivacyPage />} />
            <Route path="/legal/terms" element={<TermsPage />} />
            <Route path="/legal/refund" element={<RefundPage />} />
            <Route path="/legal/delete-account" element={<DeleteAccountPage />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  <PricingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subjects"
              element={
                <ProtectedRoute>
                  <SubjectsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subjects/:subjectId/classes"
              element={
                <ProtectedRoute>
                  <ClassesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subjects/:subjectId/classes/:classId/topics"
              element={
                <ProtectedRoute>
                  <TopicsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tutor/:sessionId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quiz/:topicId"
              element={
                <ProtectedRoute>
                  <QuizPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/materials/:topicId"
              element={
                <ProtectedRoute>
                  <MaterialsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/progress"
              element={
                <ProtectedRoute>
                  <ProgressPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/challenges/:topicId"
              element={
                <ProtectedRoute>
                  <ChallengesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/papers/:topicId"
              element={
                <ProtectedRoute>
                  <PastPapersPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </SubscriptionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
